import React from "react";

export default function CardMenu({ children }) {
  return <div className="card-menu">{children}</div>;
}
